/**
 * De onde vem o dado da tela de Ads, e como dizer isso no subtítulo.
 *
 * Regra da casa (reclamações, promoções): a tela sempre diz de quando é o dado. Aqui são DOIS relógios
 * (ver memória "tempo real tem dois relógios"): a hora do retrato da coleta (Mongo) e até que dia o
 * Meli já consolidou (D-1, consolidação às 10h). Nunca remova a data "para ficar mais limpo".
 */
import type { ColetaStatus } from './logic'

/** Mais que isto desde a última coleta OK = "COLETA ATRASADA" (mesma régua das promoções). */
export const COLETA_ATRASADA_HORAS = 26

function ddmm(d: Date): string {
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'America/Sao_Paulo' })
}

function hhmm(d: Date): string {
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' })
}

export function subtituloFonte(st: ColetaStatus | null, agora: Date): string {
  const s = st?.status
  if (!s || !s.terminado_em) {
    if (st?.rodando) {
      const ini = st.iniciado_em ? new Date(st.iniciado_em) : null
      return `coleta em andamento${ini && !Number.isNaN(ini.getTime()) ? ` desde ${hhmm(ini)}` : ''} — sem retrato ainda`
    }
    return 'sem coleta ainda — clique Atualizar'
  }
  const fim = new Date(s.terminado_em)
  if (Number.isNaN(fim.getTime())) return `retrato da coleta de ${s.terminado_em}`
  const partes: string[] = [`retrato da coleta de ${ddmm(fim)} ${hhmm(fim)}`]
  const base = s.hoje ? new Date(`${s.hoje}T12:00:00`) : fim
  const d1 = new Date(base.getFullYear(), base.getMonth(), base.getDate() - 1)
  partes.push(`Meli consolidado até ${ddmm(d1)}`)
  let txt = partes.join(' · ')
  const horas = (agora.getTime() - fim.getTime()) / 3600e3
  if (horas > COLETA_ATRASADA_HORAS) txt = `COLETA ATRASADA · ${txt}`
  if (s.ok === false) txt += ' · última coleta falhou (veja o status)'
  if ((s.nulos || 0) > 0) txt += ` · ${s.nulos} campos vazios na última coleta (token pode ter expirado — clique Atualizar)`
  return txt
}
